module.exports = __webpack_public_path__ + "static/media/dororoLofi.66222e69.mp3";